import colors from 'chalk'
import beep from 'beepbeep'
import { exec } from 'child_process'
import readline from 'readline'
import _getCursorPosition from 'get-cursor-position'
const { Writable } = require('stream')

const resetEffects = '\u001B[0m'
const symbols = {
    error: '[✖] ',
    warn: '[!] ',
    info: '[i] ',
    elypsis: '…',
    clock: '[◷] ',
    report: '[Ξ] '
}

export { resetEffects, beep, symbols }

export function getLineSize () {
    return process.stdout.columns - 2
}

export function getLineTop () {
    return `‾${''.padEnd(getLineSize(), '‾')}‾`
}

export function getLine () {
    return `_${''.padEnd(getLineSize(), '_')}_`
}

export function getLineBottom () {
    return `_${''.padEnd(getLineSize(), '_')}_\n`
}

export function getFilledLine (content) {
  let ret = ''
  const lineSize = getLineSize()
  content = content = content
        .match(new RegExp(`(\n)|(.{0,${lineSize}})`, 'g'))
        .filter(item => item !== '\n' && item.length > 0)
  content.forEach(line => {
    ret+= ' ' + line.padEnd(lineSize, ' ') + ' \n'
  })
  return '\n' +ret
}

export function statusLine (status, content) {
    const effect = (status === 1 || status === 'ok')
        ? colors.bgGreen.bold.white
        : (status === 2 || status === 'warning')
            ? colors.bgYellow.bold.black
            : colors.bgRed.bold.white

    content = getFilledLine(content)

    return `${resetEffects}${effect(
        `${''.padEnd(getLineSize() + 2)}` +
        `${content}` +
        `${''.padEnd(getLineSize() + 2)}`
    )}`
}

export function listItem (item, sep = '-') {
    return `    ${sep} ${item}\n`
}

export function item (itemLeft, itemRight = '', opts = {}) {
    const defaultOpts = {
        itemRightSize: 15,
        separator: '.',
        showEnd: true
    }
    opts = Object.assign({}, defaultOpts, opts)
    // we show only the endinf part of the string
    let leftItemLimit = getLineSize() - opts.itemRightSize
    itemLeft = itemLeft.toString()
    if (opts.showEnd) {
        if (itemLeft.length > leftItemLimit) {
            itemLeft = symbols.elypsis + itemLeft.toString().substr(itemLeft.length - (leftItemLimit) - 1)
        }
    } else {
        // we show the first part of the string
        if (itemLeft.length > leftItemLimit) {
            itemLeft = itemLeft.toString().substr(0, leftItemLimit - 1) + symbols.elypsis
        }
    }
    itemRight = itemRight.toString().substr(0, opts.itemRightSize)
    let dots = ''.padEnd(getLineSize() - itemRight.length - itemLeft.length, opts.separator)
    dots = colors.gray(dots)

    let line = ` ${itemLeft}${dots}${itemRight}\n`
    return line
}

export function title (title) {
    return colors.bold(`\n\n${title}\n`)
}

export function join (list, extraLine) {
    extraLine = extraLine ? '\n' : ''
    return '\n' + list.join('\n' + extraLine) + extraLine
}

export function list (list, sep = '-') {
    list = Array.isArray(list) ? list : [list]
    return `\n    ${sep} ${list.join(`\n    ${sep} `)}`
}

export function logMessage (msg) {
    return `\n${colors.bold(symbols.report)}${msg}`
}

export function infoMessage (msg, counter = 0) {
    counter = counter > 0
        ? ` ${counter}) `
        : ''
    return `\n${colors.bold.blue(symbols.info + counter)}${msg}`
}

export function getCursorPosition() {
    return _getCursorPosition.sync()
}

export function moveTo (where, data) {
    switch (where) {
        case 'lineStart':
            readline.cursorTo(process.stdout, 0)
            break;
        case 'lineEnd':
            readline.cursorTo(process.stdout, getLineSize())
            break;
        case 'position':
            // readline.cursorTo(process.stdout, getLineSize())
            process.stdout.write('\x1b[' + data.row + ';' + data.col + 'H')
            break;
        default:
            break;
    }
}

export function moveFor(row, col) {
    if (row) {
        process.stdout.write('\x1b[' + Math.abs(row) + row > 0 ? 'B' : 'A')
    }
    if (col) {
        process.stdout.write('\x1b[' + Math.abs(col) + col > 0 ? 'C' : 'D')
    }
}

export function clearLine (whole = true) {
    if (whole) {
        moveTo('lineStart')
    }
    process.stdout.write('\x1b[K')
}

export function warnMessage (msg, counter = 0) {
    counter = counter > 0
        ? ` ${counter}) `
        : ''
    return `\n${colors.bold.yellow(symbols.warn + counter)}${msg}`
}

export function errorMessage (msg, counter = 0) {
    counter = counter > 0
        ? ` ${counter}) `
        : ''
    return `\n${colors.bold.red(symbols.error + counter)}${msg}`
}

export function reportMessage (msg) {
    return colors.magenta.bold(symbols.report) + msg
}

export function timingReport (msg) {
    return colors.magenta.bold(symbols.clock) + msg
}

export function cleanColorCodes (msg) {
    return msg.replace(/\[e?\d+m/g, '')
}

export function clearTerminal () {
    // process.stdout.clearScreenDown()
    process.stdout.write('\x1B[2J\x1B[0f\u001b[0;0H')
}

export function headerMessage (msgs) {
    // msgs must be an array
    msgs = Array.isArray(msgs) ? msgs : [msgs]

    const info = colors.bgBlue.white
    let finalMsg = info(getLineTop())

    msgs.forEach(msg => {
        // removing color codes
        let rawMsg = cleanColorCodes(msg)
        let spacer = getLineSize() + 3 - rawMsg.length
        // filling the line
        msg = ' ' + msg + (''.padEnd(spacer, ' ')).substr(0, getLineSize()) + ''
        finalMsg += info(msg)
    })
    
    finalMsg += info(getLineBottom())
    return '\n\n' + finalMsg
}



// WEBPACK FOOTER //
// ./src/terminal-utils.js